export { default as FreeModal } from './FreeModal.vue';
